import type { PayloadAction } from '@reduxjs/toolkit';
import type { QuoteApprovalState, JobInvoiceItem } from 'src/types/quote-approval';

const reducers = {
  setQuoteLoading: (state: QuoteApprovalState, action: PayloadAction<boolean>) => {
    state.isLoading = action.payload;
  },

  updateTaskStatus: (
    state: QuoteApprovalState,
    action: PayloadAction<{ taskItem: JobInvoiceItem; status: 'approved' | 'rejected' }>,
  ) => {
    const { taskItem, status } = action.payload;
    const taskId = taskItem?.job_invoice_item_id;
    if (!taskId) return;

    if (status === 'approved' && !state.approvedTasks.some(
      (item) => item?.job_invoice_item_id === taskId,
    )) {
      state.approvedTasks.push(taskItem);
      state.rejectedTasks = state.rejectedTasks
        .filter((item) => item?.job_invoice_item_id !== taskId);
    }

    if (status === 'rejected' && !state.rejectedTasks.some(
      (item) => item?.job_invoice_item_id === taskId,
    )) {
      state.rejectedTasks.push(taskItem);
      state.approvedTasks = state.approvedTasks
        .filter((item) => item?.job_invoice_item_id !== taskId);
    }
  },
};

export default reducers;
